<template>
    <section class="hero-section">
        <div class="overlay"></div>

      <div class="hero-content">
         <img class="top-image" src="https://app.streamboxtv.live/Astra/uploads/TEST.png" alt="">
        <div class="text-content">
            <p class="subtitle">Welcome To </p>
<h1 class="title">StreamBox TV<br />Application</h1>
<p class="description">
    Your ultimate IPTV solution featuring a cutting-edge interface, seamless streaming, personalized playlists, and an unmatched viewing experience
</p>


          <div class="platform-buttons">
            <button class="platform android" @click="scrollToManage">
  Try StreamBox
</button>
<button class=" activate-button" @click="scrollToActivate" >
  Activate device
</button>

    
          
          </div>
        
<div class="platform-section">
  <p class="platform-title">Available on:</p>
         
            <div class="platform-icons">
              <!-- Ti dodaj slike gde treba -->
           
               <a href="https://play.google.com/store/apps/details?id=com.streamboxtv" ><img src="@/assets/googlePlay.png" alt="Google Play" />  </a>
              
               <a href="https://www.amazon.com/gp/product/B0F8XSW84W" ><img src="@/assets/amazonFire.png" alt="Amazon" />  </a>
          <img src="@/assets/samsungPoweredByTizen.png" alt="Amazon Fire TV" class="platform-logo" />
               <a href="https://streamboxtv.live/app.apk" ><img src="@/assets/customAPKIcon.png" alt="Google Play" />  </a>

            </div>
          </div>
         
        </div>
  
 
      </div>
    </section>
    <div id="line"></div>
  </template>
  
  <script>
  export default {
    name: "LandingHero",
    methods: {
  scrollToManage() {
    const target = document.getElementById("upload-container");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  },
  scrollToActivate() {
    const target = document.getElementById("activate-container");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }
}

  };

  </script>
  
  <style scoped>
.hero-section {
  color: white;
  padding:100px 20px;
  background: url("@/assets/back.jpg") no-repeat center bottom;
  background-size: cover;
 
  position: relative;
}

  
  .hero-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    max-width: 1920px;
    margin: auto;
  }
  
  .text-content {
    flex: 1 1 500px;
    max-width: 1200px;
  }
  
  .subtitle {
    color: #74c0ff;
    font-size: 1rem;
    margin-bottom: 10px;
  }
  
  .title {
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 20px;
    filter: drop-shadow(0 0 30px #0f3b99);
  }
  
  .description {
    font-size: 1.1rem;
    color: #ccc;
    margin-bottom: 30px;
    filter: drop-shadow(0 0 30px #0f3b99);
    text-shadow:1px 1px 5px rgba(0, 0, 0, 0.671);
  }
  
.platform-buttons {
  display: flex;
  justify-content: center; /* horizontalno centrirano */
  align-items: center;     /* vertikalno poravnato */
  gap: 15px;
  margin: 30px auto;       /* razmak od teksta iznad i ispod */
  flex-wrap: wrap;
  text-align: center;
}

  
  .platform {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 18px;
    background: #2a84ff;
 outline:none;
 border:none;
    color: white;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s;
         box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.623);
  }
  
  .platform img {
    height: 20px;
  }
  
  .platform:hover {
    background-color: white;
    color: black;
  }

.tv-image {
  max-width: 100%;
  height: auto;

  filter: drop-shadow(0 0 50px #0f3b99);
}

  
  @media (max-width: 768px) {
    .hero-content {
      flex-direction: column;
      text-align: center;
    }
    .top-image{
   width:90%;
      filter: drop-shadow(0 0 100px #028fe0);
}
 
    .text-content, .image-content {
      max-width: 100%;
    }
  
    .title {
      font-size: 2.2rem;
    }
  
    .platform-buttons {
      justify-content: center;
    }
  }
  .hero-section {
  position: relative;
  /* ostalo kao gore */
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 121, 255, 0.199);
  z-index: 1;
}

.hero-content {
  display: flex;
  flex-direction: column; /* jedan ispod drugog */
  justify-content: center; /* vertikalno centrirano */
  align-items: center; /* horizontalno centrirano */
  text-align: center;
  min-height: 100vh; /* da zauzme ceo ekran */
  position: relative;
  z-index: 2;
}

@media (max-width: 768px) {
    .hero-section{
        padding:30px;
    }
    .platform-icons{
      justify-content: center;
      text-align: center;
    }
  .hero-content {
    flex-direction: column;
  
  }

  .text-content,
  .image-content {
    max-width: 100%;
  }

  .image-content {
    justify-content: center; /* 🟢 centriraj sliku */
    text-align: center;
    padding-left: 0;
    margin-top: -20px;
  }

  .title {
    font-size: 2.2rem;
  }

  .platform-buttons {
    justify-content: center;
    
  }
    .top-image{
   width:95%;
      filter: drop-shadow(0 0 100px #028fe0);
}
}
@media (min-width: 768px) {
  .top-image{
   width:45%;
      filter: drop-shadow(0 0 100px #028fe0);
}
}



#line {
  width: 100%;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(0, 99, 255, 1) 9%,
    rgba(23, 46, 147, 1) 27%,
    rgba(222, 0, 127, 1) 46%,
    rgba(0, 72, 202, 1) 65%,
    rgba(171, 0, 78, 1) 82%,
    rgba(9, 9, 121, 1) 100%
  );
  background-size: 200% 100%;
  animation: move-gradient 10s linear infinite alternate;
  box-shadow: 0px 5px 20px rgb(0, 0, 0);
  margin-top: 0px; /* da ne seče nav */
}

@keyframes move-gradient {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 100% 0%;
  }
}
.platform-section {
    margin: 20px 0;
  }
  
  .platform-title {
        text-shadow:1px 1px 5px rgba(0, 0, 0, 0.671);
    font-weight: bold;
    margin: 20px 0;
    margin-top:50px;
    font-size: 2rem;
  }
  .platform-icons {
  display: flex;
  justify-content: center; /* horizontalno centrirano */
  align-items: center;     /* vertikalno poravnato */
  gap: 15px;
  margin: 30px auto;       /* razmak od teksta iznad i ispod */
  flex-wrap: wrap;
  text-align: center;

}

.platform-icons img {
  height: 50px;
  filter: drop-shadow(0 0 5px #0f3b99);
  flex-shrink: 0;
}

  .activate-button{
    padding: 12px 24px;
    font-size:1.1em;
    border: none;
    color: white;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s;
    text-shadow:1px 1px 20px rgba(0, 0, 0, 0.699);
    background: linear-gradient(135deg, #ffc400, #FF8C00);
      box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.623);
  }
  
  .platform {
    padding: 12px 24px;
    background: #2a84ff;
    border: none;
    color: white;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s;
  }
  
  .platform:hover{
    background: white;
    color:black;
  }

  </style>
  